import { useCallback, useRef } from 'react';

import { OffersCountTooltip } from 'shared/components/OffersCountTooltip';
import { ELabelView } from 'shared/components/PopupFilterControlled/types';
import { RangeInputContainer } from 'shared/components/RangeInputContainer';
import { EAreaMeasure } from 'shared/enums/EAreaMeasure';
import { EFilterType } from 'shared/enums/EFilterType';
import { isCommercialLand } from 'shared/utils/filters/isCommercialLand';
import { getRangeLabel } from 'shared/utils/getRangeLabel';
import { useFilters } from 'shared/utils/hooks/useFilters';
import { useFiltersActions } from 'shared/utils/hooks/useFiltersActions';
import { useOffersCountTooltip } from 'shared/utils/hooks/useOffersCountTooltip';
import { useOffersCountTooltipActions } from 'shared/utils/hooks/useOffersCountTooltipActions';
import { memoWithDisplayName } from 'shared/utils/memoWithDisplayName';

import { PopupFilterControlled } from '../../PopupFilterControlled';

import styles from './TotalAreaFilter.css';

export const TotalAreaFilter = memoWithDisplayName(() => {
  const filters = useFilters();
  const totalArea = filters.totalArea;

  const containerRef = useRef(null);

  const { changeTotalAreaMinAction, changeTotalAreaMaxAction } = useFiltersActions();

  const { openedAtCurrentTarget } = useOffersCountTooltip(EFilterType.totalArea);
  const { setTargetOffersCountTooltip } = useOffersCountTooltipActions();

  const handleChangeMin = useCallback(
    (value: number) => {
      setTargetOffersCountTooltip(EFilterType.totalArea);
      changeTotalAreaMinAction(value);
    },
    [setTargetOffersCountTooltip, changeTotalAreaMinAction],
  );

  const handleChangeMax = useCallback(
    (value: number) => {
      setTargetOffersCountTooltip(EFilterType.totalArea);
      changeTotalAreaMaxAction(value);
    },
    [setTargetOffersCountTooltip, changeTotalAreaMaxAction],
  );

  const postfix = isCommercialLand(filters) ? EAreaMeasure.Ares : EAreaMeasure.SquareMeters;

  const content = (
    <OffersCountTooltip hostElement={containerRef.current} opened={openedAtCurrentTarget} placement="right">
      <div className={styles['container']}>
        <RangeInputContainer
          isFormattedInput
          maxWidth={248}
          postfix={postfix}
          valueMax={totalArea?.max}
          valueMin={totalArea?.min}
          onChangeMax={handleChangeMax}
          onChangeMin={handleChangeMin}
        />
      </div>
    </OffersCountTooltip>
  );

  return (
    <div ref={containerRef}>
      <PopupFilterControlled
        filterType={EFilterType.totalArea}
        label={getRangeLabel(totalArea, postfix)}
        labelView={ELabelView.Button}
        placeholder="Площадь"
        popupContent={content}
      />
    </div>
  );
}, 'TotalAreaFilter');
